export const encounterTypes = ["ConsentCall", "ConsentVisit", "InitialAssessment", "FollowUpAssessment", "Surveillance"];
export const encounterTypesWelfare = ["WelfareCheck"];
export const contactMethodTypes = ["Phone", "Visit", "Email", "Other"];
export const locationTypes = ["Home", "ResidentialCare"];

export const createOption = value => ({
  value,
  label: value.replace(/([A-Z])/g, " $1").trim(),
});
